import { Logo } from '@src/components/atoms/logo';

import { Header, HeaderContent, LogoWrapper } from './styles';
import { AuthLayoutHeaderProps } from './types';

const AuthLayoutHeader = ({ children, source, size = 'normal' }: AuthLayoutHeaderProps) => {
  const isBusiness = source === 'business';

  return (
    <Header size={size}>
      <LogoWrapper size={size}>
        <Logo isBusiness={isBusiness} />
      </LogoWrapper>

      {!isBusiness && <HeaderContent>{children}</HeaderContent>}
    </Header>
  );
};
export default AuthLayoutHeader;
